<template>
    <div class="ConnaitrePartenaires">
        <HeadPage :title="'Nos partenaires'" 
                  :category="'Nous connaitre'"
                  :img="null"
                  :imgAlt="null"
        />
        <br>
        <br>
        <br>
        <Partners :items="PARTNERS"
                :limit="4"
                :auto="true"
                type="partners"
            />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import Partners from '../global/Partners.vue'
import {PARTNERS} from "../../constant/PARTNERS";

export default {
    name: "ConnaitrePartenaires",
    components: {
        HeadPage,
        Partners
    },
    data() {
      return {
        PARTNERS
      }
    }
}
</script>

<style scoped>
/* 
* Global 
*/
.ConnaitrePartenaires {
    padding-bottom: 75px;
}
</style>